import React, { useEffect, useRef, useState } from "react";
import { Player } from "bitmovin-player";
import { UIFactory } from "bitmovin-player/bitmovinplayer-ui";
import { fetchPlayApiSource } from "@repo/utils";
import "bitmovin-player/bitmovinplayer-ui.css";

function BitmovinPlayer() {
  const [player, setPlayer] = useState(null);
  const playerDiv = useRef(null);

  const playerConfig = {
    key: "378a99c6-1097-4afa-a8a8-a70762280eb1",
    analytics: {
      key: "3f192444-fe35-4655-9b7d-ae3a30b0bc52",
    },
    ui: false,
    network: {
          preprocessHttpRequest: (type, request) => {
            if (type === ('drm/certificate/fairplay')) {
              request.responseType = 'arraybuffer'
            }
            if (type === ('drm/license/fairplay')) {
              request.credentials = 'include'
            }
            return Promise.resolve(request)
          },
        },
  };

useEffect(() => {
  let cancelled = false;
  let playerInstance = null;

  async function setupPlayer() {
    try {
      const AdvertisingBitmovinModule = (
        await import("bitmovin-player/modules/bitmovinplayer-advertising-bitmovin")
      ).default;

      const { srcCfg, ads } = await fetchPlayApiSource(
        "https://api.dev.streaming.channel4.com/1.6/A/ENG/DOTCOM/ALL/PLAY/VOD/1000000028",
      );

      if (cancelled) return;

      Player.addModule(AdvertisingBitmovinModule);

      if (cancelled) return;
      if (!playerDiv.current) return;

      // avoid mutating a shared config object
      const config = {
        ...playerConfig,
        advertising: {
          adBreaks: [ads],
        },
      };

      playerInstance = new Player(playerDiv.current, config);
      UIFactory.buildDefaultUI(playerInstance);

      await playerInstance.load(srcCfg);

      if (cancelled) return;

      setPlayer(playerInstance);
      console.log("Successfully loaded source");
    } catch (err) {
      if (!cancelled) console.warn(err);
    }
  }

  setupPlayer();

  return () => {
    cancelled = true;

    if (player != null) {
      player.destroy();
      setPlayer(null);
    }
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  return <div id="player" ref={playerDiv} />;
}

export default BitmovinPlayer;
